import { provide, inject, InjectionKey } from '@vue/composition-api';

export const provideTeamIdKey: InjectionKey<string> = Symbol();

export const provideTeamId = (teamId: string) => {
  provide(provideTeamIdKey, teamId);
};

export const useTeamId = () => {
  return inject(provideTeamIdKey)!;
};
